import React from 'react';
import { Link } from 'react-router-dom';
import './ISO10002.css';

const ISO10002 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 10002 Customer Satisfaction Management System</h1>
            <h2 className="page-subtitle">A Good Company Starts with Satisfied Customers: ISO 10002</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we take pride in offering you the ISO 10002 
                Customer Satisfaction Management System with an approach that prioritizes customer satisfaction. 
                Customer satisfaction is one of the cornerstones of success in today's competitive business 
                world. This standard provides guidance to businesses on effectively managing customer 
                complaints and enhancing customer satisfaction.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 10002?</h2>
            <div className="page-text-content">
              <p>
                ISO 10002 is a management system designed for businesses that adopt a customer-centric 
                approach. Its main purpose is to effectively address customer complaints, find solutions, 
                and continuously improve customer satisfaction, providing organizations with a clear framework.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Principles of ISO 10002:</h2>
            <div className="principles-list">
              <div className="principle-item">
                <h3 className="principle-title">1. Customer Complaint Management</h3>
                <p className="principle-description">
                  ISO 10002 supports a management system that effectively identifies, records, evaluates, 
                  and resolves customer complaints.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">2. Improvement Processes</h3>
                <p className="principle-description">
                  The standard guides businesses in creating processes for learning from customer feedback 
                  and continuous improvement.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">3. Staff Training</h3>
                <p className="principle-description">
                  Encourages employee training to foster a culture focused on customer satisfaction.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">4. Transparency and Communication</h3>
                <p className="principle-description">
                  ISO 10002 recommends organizations to provide open and transparent communication with 
                  customers.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Benefits of ISO 10002 for Businesses:</h2>
            <div className="benefits-list">
              <div className="benefit-item">
                <h3 className="benefit-title">1. Increasing Customer Satisfaction</h3>
                <p className="benefit-description">
                  ISO 10002 guides businesses in effectively addressing customer complaints, thereby 
                  increasing customer satisfaction.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">2. Transparent Communication</h3>
                <p className="benefit-description">
                  The standard helps organizations establish transparent communication with customers.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">3. Building Customer Trust</h3>
                <p className="benefit-description">
                  By professionally addressing customer complaints, businesses can enhance customer trust.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">4. Gaining Competitive Advantage</h3>
                <p className="benefit-description">
                  ISO 10002 provides a competitive advantage to businesses focusing on customer satisfaction.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO10002;

